module.exports = __webpack_public_path__ + "static/1065782694.7aed912d.jpg";